import styled from "styled-components";
import { Toolbar as MuiToolbar } from "@material-ui/core";

export const Toolbar = styled(MuiToolbar)`
    height: 80px;
`;

export default Toolbar;
